import { type FormKitNode } from '@formkit/core'

const contains_special_char = function (node: FormKitNode) {
  if (typeof node.value !== 'string') return false
  return /[^\p{L}\p{N}]/u.test(node.value)
}

export default contains_special_char
